import React from "react";
import { Form, Button } from "react-bootstrap";
import InputMask from "react-input-mask";
import {
  validatePassword,
  handleSignUp,
  updateUserPoolAttributes,
  getCurrentAuthenticatedUser,
  handleFederatedAuthentication,
  checkDuplicatePhoneNumberUser,
} from "../../helper";
import ERRORS from "../../constants/errors";
import { FaFacebookF, FaGoogle } from "react-icons/fa";
import { validateSignup } from "./validation";

export default function New(props) {
  const {
    handleFormChange,
    showAlert,
    closeSignupModal,
    email,
    username,
    given_name,
    handleFormInputChange,
    openLoginModal,
    completeSocialSignup,
    setVerifyPhoneNumber,
    isMobile,
  } = props;

  const handleSubmitSignUp = async (event) => {
    event.preventDefault();
    const payload = {
      given_name,
      phone_number:
        username && username.startsWith("+91") ? username : `+91${username}`,
      email,
    };
    const validationResult = validateSignup(payload);
    if (validationResult.error) {
      showAlert("Signup", validationResult.error, false);
    } else {
      const duplicationStatus = await checkDuplicatePhoneNumberUser(
        payload.phone_number
      );
      if (
        duplicationStatus.$response &&
        duplicationStatus.$response.data &&
        duplicationStatus.$response.data.Users &&
        duplicationStatus.$response.data.Users.length > 0
      ) {
        showAlert(
          "Complete Sign up",
          "A user with the given phone number already exists. Please choose a different phone number or sign in from the registered account.",
          false
        );
        return null;
      }
      if (completeSocialSignup) {
        await getCurrentAuthenticatedUser().then(
          async (user) =>
            await updateUserPoolAttributes(user, {
              email,
              given_name,
              phone_number:
                username && username.startsWith("+91")
                  ? username
                  : `+91${username}`,
              address: JSON.stringify([]),
            })
              .then(() => setVerifyPhoneNumber(true))
              .then(() => handleFormChange("otp"))
              .then(() =>
                showAlert(
                  "Complete Social Signup",
                  "A verification OTP has been sent to the phone number successfully",
                  true
                )
              )
              .catch((error) =>
                showAlert("Complete Social Signup", error.message)
              )
        );
      } else {
        const password =
          given_name.toUpperCase().substring(0, 4) +
          String(username).substring(String(username).length - 4);
        if (validatePassword(password)) {
          await handleSignUp(
            username,
            given_name,
            email,
            JSON.stringify([]),
            password
          )
            .then(() => showAlert("Signup", "OTP sent successfully", true))
            .then(() => handleFormChange("otp"))
            .catch((error) => {
              showAlert("Signup", error.message);
              closeSignupModal();
            });
        } else {
          showAlert("Signup", ERRORS.PASSWORD_POLICY_MISMATCH);
        }
      }
    }
  };

  return (
    <div className="landing-form">
      {completeSocialSignup && (
        <p className="mb-3 text-center">
          You are almost done signing up. We just need to confirm the following
          details for verification.
        </p>
      )}
      <Form onSubmit={handleSubmitSignUp}>
        <Form.Group>
          <Form.Label className="landing-label">Full Name</Form.Label>
          <Form.Control
            className="landing-input"
            type="text"
            placeholder="Enter Full Name"
            name="given_name"
            value={given_name}
            onChange={handleFormInputChange}
            disabled={completeSocialSignup && given_name}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="landing-label">Email</Form.Label>
          <Form.Control
            className="landing-input"
            type="text"
            placeholder="Enter Email"
            name="email"
            value={email}
            onChange={handleFormInputChange}
            disabled={completeSocialSignup && email}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="landing-label">Phone Number</Form.Label>
          <InputMask
            mask="+\919999999999"
            maskChar={null}
            placeholder="Enter Username/Phone Number"
            value={username}
            name="username"
            onChange={handleFormInputChange}
            className="form-control"
          />
          <div
            className="landing-links mt-3"
            onClick={() => {
              closeSignupModal();
              openLoginModal();
            }}
          >
            <p className="text-center">Already have an account? Login.</p>
          </div>
        </Form.Group>
        <Form.Group className="d-flex justify-content-center w-100">
          <Button
            variant="outline-warning"
            className="landing-button w-50"
            type="submit"
          >
            Sign Up
          </Button>
        </Form.Group>
      </Form>
      {!completeSocialSignup && (
        <>
          <div className={`mx-auto mt-3 ${isMobile ? "w-100" : "w-50"}`}>
            <Button
              className="w-100"
              style={{ backgroundColor: "#3B5998", border: "none" }}
              onClick={async () => handleFederatedAuthentication("Facebook")}
            >
              <FaFacebookF color="white" /> Login/Signup using Facebook
            </Button>
          </div>
          <div className={`mx-auto mt-2 ${isMobile ? "w-100" : "w-50"}`}>
            <Button
              className="w-100"
              style={{ backgroundColor: "#dd4b39", border: "none" }}
              onClick={async () => handleFederatedAuthentication("Google")}
            >
              <FaGoogle color="white" className="mr-2" />
              Login/Signup using Google
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
